export const DELAY_TIME_IN_DAYS = 4;
